import React from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

// import videoApi from "./../../../../api/videoApi";
import Card from '../../../../../component/Card';
import Video_title from '../../../../../component/Video_title';
import checkApiStatus from '../../../../../component/SubscripStatus';
import CustomPagination from '../../../../../component/Pagination/CustomPagination';
import api from '../../../../../data/api';
import VideoThumbnailCard from '../../../../components/VideoThumbnailCard';
import NoVideosFoundSection from '@/v2/components/NoVideosFoundSection';
import { getSignupRoute } from '@/constants/featureFlags';

const VideoSection = ({
	category,
	isLoggedIn,
	userData,
	setUserData,
	savedVideoIds,
	setSavedVideoIds,
	responseData,
	setResponseData,
	selectedTags,
	selectTagCallback,
	setSelectedTags,
	setModal,
	setVideoData2,
	handleShuffle,
	totvideos,
	currentPage,
	handlePageChange,
	modal,
	setVideoData
}) => {
	const navigate = useNavigate();

	// Handle video player navigation
	const handlePlayerVideo = async id => {
		const apistatus = await checkApiStatus(userData.token, setUserData);
		if (isLoggedIn) {
			if (apistatus) {
				navigate(`/PlayerPage?v=${id}`);
			} else {
				navigate('/Plans');
			}
	} else {
			navigate(getSignupRoute());
		}
	};

	// Handle like/unlike
	const handleLikeDislike = async (id, video) => {
		const isLiked =
			video.videoDetails?.savedvideo ||
			video.savedvideo ||
			(savedVideoIds?.length > 0 && savedVideoIds?.includes(video?.videoDetails?._id || video?._id));
		try {
			if (isLiked) {
				const response = await api.unsaveWishlist(id, userData?.token);
				if (response.status === 200) {
					updateVideoSavedStatus(id, false);
				}
			} else {
				const response = await api.saveWishlist(id, userData?.token);
				if (response.status === 200) {
					updateVideoSavedStatus(id, true);
				}
			}
		} catch (error) {
			console.error('Error fetching data: ', error);
		}
	};

	// Update video saved status in state
	const updateVideoSavedStatus = (videoId, savedStatus) => {
		const updatedResponseData = responseData.map(item => {
			const updatedVideos = item.videos.map(video => {
				if (video?.videoDetails?._id === videoId) {
					return {
						...video,
						videoDetails: {
							...video.videoDetails,
							savedvideo: savedStatus
						}
					};
				} else if (video?._id === videoId) {
					return {
						...video,
						savedvideo: savedStatus
					};
				}
				return video;
			});
			return {
				...item,
				videos: updatedVideos
			};
		});

		setResponseData(updatedResponseData);
	};

	// Add to playlist
	const handleSubmitPlaylist = async _id => {
		try {
			const response = await api.videoPlayerPage(_id, userData.token);
			if (response.status === 200) {
				setModal(false);
				const jsonData = response.data[0];
				setVideoData2(jsonData);
				setModal(true);
			}
		} catch (error) {
			setModal(false);
			toast.error('Something went wrong', {
				position: 'top-center',
				duration: 3000
			});
		}
	};

	return (
		<div className="c-video" style={{ minHeight: '100vh' }}>
			<div className="row c-video_textrow c-video_list pb-0">
				<div className="col-md-8 c-video_textcol c-mobile_videotext-1">
					<h4>{category?.name}</h4>
				</div>
				<div className="col-md-4 c-video_textcol-a text-end c-mobile_videotext-2">
					<a onClick={() => handleShuffle(category?.id)}>
						<span style={{ color: '#3cb4e4' }}>
							<i className="fa-solid fa-shuffle"></i>
						</span>
						<span style={{ color: '#3cb4e4' }}>Shuffle</span>
					</a>
				</div>
			</div>
			{totvideos === 0 && <NoVideosFoundSection />}
			<div className="c-video_list">
				<div className="row m-0">
					{category?.videos?.map((video, index) => (
						<div key={index} className="mb-2">
							<VideoThumbnailCard
								key={index}
								content={video}
								isLoggedIn={isLoggedIn}
								handlePlayerVideo={handlePlayerVideo}
								handelSubmitPlaylist={handleSubmitPlaylist}
								handleSaveUnsave={handleLikeDislike}
								savedVideos={savedVideoIds}
								modal={modal}
								setModal={setModal}
								setVideoData={setVideoData}
								titleStyles={{ fontSize: 'clamp(1.15rem, 1.2vw, 1.6rem)' }}
								selectedTags={selectedTags}
								selectTagCallback={selectTagCallback}
							/>
						</div>
					))}
				</div>
			</div>

			<CustomPagination totalPages={totvideos} currentPage={currentPage} onPageChange={handlePageChange} />
		</div>
	);
};

export default VideoSection;
